var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.items.length > 0,
          expression: "items.length > 0"
        }
      ],
      staticClass: "popup",
      style: { left: _vm.left + "px", top: _vm.top + "px" }
    },
    _vm._l(_vm.items, function(item, k) {
      return _c(
        "div",
        { key: k, staticClass: "item-wrapper" },
        [_c("rack-item-details", { attrs: { item: item } })],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
/* hot reload */
if (module.hot) {
  var api = require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (module.hot.data) {
      require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js").rerender('8055b97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    }
  }
}export { render, staticRenderFns }